<svg
  [attr.width]="size"
  [attr.height]="size"
  viewBox="0 0 24 24"
  xmlns="http://www.w3.org/2000/svg"
>
  <path d="M8.79289 19.6213L2.29288 13.1213C1.90237 12.7308 1.90237 12.0976 2.29288 11.7071L3.70706 10.2929C4.09757 9.90233 4.73077 9.90233 5.12128 10.2929L9.5 14.6716L18.8787 5.29288C19.2692 4.90237 19.9024 4.90237 20.2929 5.29288L21.7071 6.7071C22.0976 7.09761 22.0976 7.73077 21.7071 8.12132L10.2071 19.6214C9.81656 20.0119 9.1834 20.0119 8.79289 19.6213Z"/>
</svg>
